export default {
  en: {
    addResource: 'Add @:resource',
    attribute: 'attribute',
    custom_resources: 'Custom resources',
    nItems: '<b>{n}</b> items | <b>{n}</b> item | <b>{n}</b> items',
    noCategory: 'No category',
    nResults: '<b>{n}</b> results | <b>{n}</b> result | <b>{n}</b> results',
    ofNItems: 'of <b>{n}</b> items | of <b>{n}</b> item | of <b>{n}</b> items',
    searchResources: 'Search resources',
    values: {
      attribute: {
        name: '@:Resource name',
        id: '@:Resource ID',
        provider: '@:provider',
        category: 'Category',
        type: 'Type',
        tags: '@:untranslated.tags',
        project: '@:Project',
        environment: '@:Environment',
        component: '@:Component',
        location: 'Location',
        link: 'Link',
        stack: '@:Stack',
        owner: '@:owner',
      },
    },
  },
  es: {
    addResource: 'Añadir @:resource',
    attribute: 'atributo',
    custom_resources: 'Recursos personalizados',
    nItems: '<b>{n}</b> elementos | <b>{n}</b> elemento | <b>{n}</b> elementos',
    noCategory: 'Sin categoría',
    nResults: '<b>{n}</b> resultados | <b>{n}</b> resultado | <b>{n}</b> resultados',
    ofNItems: 'de <b>{n}</b> elementos | de <b>{n}</b> elemento | de <b>{n}</b> elementos',
    searchResources: 'Buscar recursos',
    values: {
      attribute: {
        name: 'Nombre del @.lower:Resource',
        id: 'ID del @.lower:Resource',
        provider: '@:provider',
        category: 'Categoría',
        type: 'Tipo',
        tags: '@:untranslated.tags',
        project: '@:Project',
        environment: '@:Environment',
        component: '@:Component',
        location: 'Ubicación',
        link: 'Enlace',
        stack: '@:Stack',
        owner: '@:owner',
      },
    },
  },
  fr: {
    addResource: 'Ajouter une @:resource',
    attribute: 'attribut',
    custom_resources: 'Ressources personnalisées',
    nItems: '<b>{n}</b> éléments | <b>{n}</b> élément | <b>{n}</b> éléments',
    noCategory: 'Aucune catégorie',
    nResults: '<b>{n}</b> résultats | <b>{n}</b> résultat | <b>{n}</b> résultats',
    ofNItems: 'de <b>{n}</b> éléments | de <b>{n}</b> élément | de <b>{n}</b> éléments',
    searchResources: 'Rechercher des ressources',
    values: {
      attribute: {
        name: 'Nom de la @.lower:Resource',
        id: 'ID de la @.lower:Resource',
        provider: '@:provider',
        category: 'Catégorie',
        type: 'Type',
        tags: '@:untranslated.tags',
        project: '@:Project',
        environment: '@:Environment',
        component: '@:Component',
        location: 'Emplacement',
        link: 'Lien',
        stack: '@:Stack',
        owner: '@:owner',
      },
    },
  },
}
